import * as React from 'react';
import { ManagerWorkflowStore } from 'nomst/Stores/Decision/managerWorkflow.store';
import { buildClassString } from '@payscale/payscale-shared-ui/lib/StringUtils';
import { DecisionDispatcher } from 'nomst/Stores/Decision/decision.dispatcher';
import { WorkflowAction } from 'nomst/Stores/Decision/Constants/workflowAction';
import './sendForReviewButton.scss';
import { User } from 'nomst/Stores/User/user';

interface ISendForReviewProps {
    managerWorkflowStore: ManagerWorkflowStore;
    decisionDispatcher: DecisionDispatcher;
    user: User
}

const buildButtonClassString = (className: string, isPrimary: boolean): string => {
    return buildClassString({
        [className]: !!className,
        'pxl-btn': true,
        'pxl-btn--sm': true,
        'pxl-btn--primary': isPrimary
    });
};

export const SendForReviewButton = (props: ISendForReviewProps) => {

    const handleSubmitForReview = (): void => {
        const { decisionDispatcher } = props;
        decisionDispatcher.dispatchWorkflowAction(WorkflowAction.SubmitReview);
    };

    const isSendForReviewButtonVisible = (): boolean => {
        return props.managerWorkflowStore.isSendForReviewButtonVisible(props.user) ?? false;
    };

    if (!isSendForReviewButtonVisible()) {
        return null;
    }
 
    return (
        <div className="send-for-review-button">
            <i className="icon-bell"></i>
            <p>Click send for review to submit recommendations</p>
            <i className="icon-right-open"></i>
            <button
                className={buildButtonClassString('review-btn', true)}
                onClick={handleSubmitForReview}
            >
                Send for Review
            </button>
        </div>
    );
};